import {
    ProcessedAudioArticlesRecommendationsItem,
    resolveImageSrc,
} from "../audioArticlesRecommendationsUtils";
import { AudioArticlesRecommendationsAction, AudioArticlesRecommendationsItemCard } from "./audioArticlesRecommendationsItemCard";

const RECOMMENDATIONS_ACTIONS: AudioArticlesRecommendationsAction[] = ["share", "youtube", "apple", "spotify"];

type AudioArticlesRecommendationsComponentaAppProps = {
    listData?: ProcessedAudioArticlesRecommendationsItem[];
    imagesDomain: string;
    domain: string;
};

const scriptBepoRecommendationsPanel = `
    document.addEventListener("onWcmBepoRecommendationsOpen", function() {
        var el = document.querySelector(".AudioArticlesRecommendationsComponentaApp");
        if (el) { el.classList.remove("isHidden"); }
    });
    document.addEventListener("click", function(e) {
        var target = e.target;
        if (!target || !target.classList || !target.classList.contains("closeButton")) {
            return;
        }
        var panel = target.closest ? target.closest(".AudioArticlesRecommendationsComponentaApp") : null;
        if (panel) { panel.classList.add("isHidden"); }
    });
`;

export class AudioArticlesRecommendationsComponentaApp extends React.Component<AudioArticlesRecommendationsComponentaAppProps, {}> {

    public static siteScriptName = "AudioArticlesRecommendationsComponentaApp";

    render() {
        const { listData, imagesDomain, domain } = this.props;

        if (!listData || listData.length === 0) {
            return null;
        }

        return (
            <>
                <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptBepoRecommendationsPanel }} />
                <div className="AudioArticlesRecommendationsComponentaApp isHidden">
                    <div className="recommendationsContainer">
                        <button className="closeButton" aria-label="close" type="button" />
                        <div className="recommendationsContent">
                            <div className="recommendationsHeader">
                                <div className="headerTitleRow">
                                    <div className="headerLogoWrap">
                                        <span className="headerLogo" aria-hidden="true" />
                                    </div>
                                    <h3 className="headerTitle">אולי יעניין אתכם: חדש ב-</h3>
                                </div>
                            </div>

                            <div className="itemsContainer">
                                {_.map(listData, (item: ProcessedAudioArticlesRecommendationsItem) => {
                                    const podcastId = item.id || item.articleId;
                                    if (!podcastId) {
                                        return null;
                                    }

                                    const imageSrc = resolveImageSrc(item.imageUrl || "", imagesDomain || "");
                                    const resolvedCategoryIconSrc = resolveImageSrc(
                                        item.categoryIcon || item.categoryIconSrc || "",
                                        imagesDomain || "",
                                    );
                                    const isVideoItem = item.hasVideo && item.videoData;
                                    const video = item.videoData;
                                    const mediaDuration = isVideoItem && item.videoData.duration
                                        ? item.videoData.duration
                                        : (item.duration || 0);
                                    const scriptObj = {
                                        id: podcastId,
                                        name: item.author || "",
                                        title: item.title,
                                        durationSeconds: mediaDuration,
                                        imageUrl: imageSrc || item.imageUrl || "",
                                        audioUrl: isVideoItem ? undefined : item.audioUrl || "",
                                        articleLink: item.link,
                                        podcastCategoryImage: resolvedCategoryIconSrc,
                                        podcastName: item.categoryName || "",
                                    };
                                    const scriptString = `window.podcastsData = window.podcastsData || {};
                                    window.podcastsData[${JSON.stringify(podcastId)}] = ${JSON.stringify(scriptObj)};`;

                                    return (
                                        <AudioArticlesRecommendationsItemCard
                                            key={item.id}
                                            item={item}
                                            imagesDomain={imagesDomain}
                                            categoryIconFirst={true}
                                            actions={RECOMMENDATIONS_ACTIONS}
                                            useNativeActionLinks={true}
                                            href={isVideoItem ? `${domain}/video?path=${video.url}?videoId=${video.mediaId}&articleId=${podcastId}&advertisement=${item.hideVideoAds ? '0' : '1'}&blockAbroad=${video.blockAbroadViews ? `1` : `0`}${video.aspectRatio ? `&proportion=${video.aspectRatio}` : ""}${`&caption=${item.title}`}` : "//podcast/" + podcastId}
                                        >
                                            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />
                                        </AudioArticlesRecommendationsItemCard>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
